import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SupportModalIdSubComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-id-sub-test-header',
  templateUrl: './id-sub-test-header.component.html',
  styleUrls: ['./id-sub-test.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdSubTestHeaderComponent extends SupportModalIdSubComponent {
  destroy() {}
  init() {}
  reload() {}

  constructor(private _common: CommonLibService) {
    super(_common);
  }
}
